import useEventDetailsGrid from "@hooks/useEventDetailsGrid";
import useComplianceView from "@hooks/useComplianceView";
import IncidentClient from "@common/api/IncidentClient";
import LoginAction from "@common/redux/actions/LoginAction";
import UploadAction from "@common/redux/actions/UploadAction";
import { handleError } from "@common/components/helpers/error";
import SetupAction from "@common/redux/actions/SetupAction";
import SessionalPositionsAction from "@common/redux/actions/SessionalPositionsAction";
import useLinkSession from "@common/components/hooks/useLinkSession";
import {
  GAMBLING_DISPUTE_TYPE,
  SUSPICIOUS_ACTIVITY_TYPE,
} from "../components/Compliance/details/EventDetailsForm";

function useIncidentContainer() {
  const {
    incident: {
      record: {
        incidentType: { name },
      },
    },
    setViewData,
  } = useComplianceView();
  const { activeRow } = useEventDetailsGrid();
  const { getComplianceSessionsByGuids } = useLinkSession();

  const onRowUpdate = (isRead = true) => {
    setViewData({ formLoading: true });
    const {
      event: { id },
    } = activeRow;

    const fnRead = isRead ? IncidentClient.Read : IncidentClient.ReadForUpdate;

    fnRead(id).then(
      (response) => {
        let incidentDetails = null;
        let sessionGuids = [];
        if (name === GAMBLING_DISPUTE_TYPE) {
          incidentDetails = response.record?.gamblingDispute;
          sessionGuids = response.record?.gamblingDispute?.sessionGuids;
        } else if (name === SUSPICIOUS_ACTIVITY_TYPE) {
          incidentDetails = response.record?.suspiciousActivity;
          sessionGuids = response.record?.suspiciousActivity?.sessionGuids;
        } else {
          incidentDetails = response.record?.incidentDetails;
          sessionGuids = response.record?.incidentDetails?.sessionGuids;
        }

        const {
          record: {
            site: { guid },
          },
        } = response;

        UploadAction.dispatch({ incidentId: id });

        SetupAction.dispatch({
          mode: incidentDetails?.machine === null ? 3 : 1,
        });
        SessionalPositionsAction.dispatch({
          activeRow: incidentDetails?.machine,
        });

        const title =
          incidentDetails?.machine?.name ?? incidentDetails?.machineRef;
        getComplianceSessionsByGuids(title, sessionGuids);

        LoginAction.dispatch({
          siteGuid: guid,
          isInReadMode: isRead,
        }).then(() => {
          setViewData({ incident: response, formLoading: false });
        });
      },
      (error) => {
        setViewData({ formLoading: false, eventsGridActiveRow: null });
        handleError(error);
      },
    );
  };

  return {
    onRowUpdate,
  };
}

export default useIncidentContainer;
